import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import {
  FormsModule,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApilistService } from '../services/apilist.service';
import { CommonService } from '../services/common.service';
import { GlobalService } from '../services/global.service';
import { CommonModule } from '@angular/common';

import { AgGridModule } from 'ag-grid-angular';
import { AgGridAngular } from 'ag-grid-angular';
import { GridApi, GridReadyEvent } from 'ag-grid-community';

import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-viewtopadmission',
  standalone: true,
  imports: [CommonModule, FormsModule, AgGridModule],
  templateUrl: './viewtopadmission.component.html',
  styleUrls: ['./viewtopadmission.component.scss'],
})
export class ViewtopadmissionComponent implements OnInit, AfterViewInit {
  display: any = 'none';
  displayDelete: any = 'none';
  category: any;
  subject: any;
  document: any;
  cources: any[];
  courseData: any;
  materialdata: any[];
  subjectdata: any[];
  showAdd = false;
  showEdit = false;
  id: any;

  courseForm: UntypedFormGroup;

  showErr = false;
  deleteErr: any;

  searchval: string = '';

  error_messages = {
    categorytypeval: [{ type: 'required', message: 'Please Select Category' }],
    Subjecttypeval: [{ type: 'required', message: 'Please Select Year' }],
    documentval: [{ type: 'required', message: 'Please enter Document Name' }],
  };
  adminName: any;
  adminImage: any;
  allCourse: any;
  allData: any;

  showData = false;
  showNodata = false;

  @ViewChild('boxCourse', { static: false }) boxCourse: ElementRef;
  @ViewChild('agGrid') agGrid!: AgGridAngular;

  docx_name: any;
  docx_file: any;
  materialdox: any;
  admissiondetails: any[] = [];
  searchData: any[] = [];

  // ag-grid API
  private gridApi!: GridApi;

  // store original data snapshot so we can restore unsorted order
  private originalRowData: any[] = [];

  // debounce subject for quick filter
  private quickFilterSubject = new Subject<string>();

  // ag-grid column definitions
  columnDefs = [
    { headerName: 'S.No', valueGetter: 'node.rowIndex + 1', maxWidth: 90 },
    {
      headerName: 'Course',
      field: 'choice_of_course',
      filter: 'agTextColumnFilter',
    },
    {
      headerName: 'College Name',
      field: 'college_name',
      filter: 'agTextColumnFilter',
    },
    { headerName: 'Name', field: 'name', filter: 'agTextColumnFilter' },
    {
      headerName: 'Phone No.',
      field: 'phone_num',
      filter: 'agTextColumnFilter',
    },
    {
      headerName: 'Father Name',
      field: 'father_name',
      filter: 'agTextColumnFilter',
    },
    {
      headerName: 'Father Phone No.',
      field: 'father_phone_num',
      filter: 'agTextColumnFilter',
    },
    { headerName: 'District', field: 'district', filter: 'agTextColumnFilter' },
    {
      headerName: 'Date',
      field: 'date',
      filter: 'agDateColumnFilter',
      valueFormatter: (params: any) => {
        if (!params.value) return '';
        const d = new Date(params.value);
        return d.toLocaleString();
      },
      minWidth: 160,
    },
  ];

  // defaultColDef = {
  //   resizable: true,
  //   sortable: true,
  //   filter: true,
  //   flex: 1,
  //   minWidth: 120,
  // };

  // bound row data (source of truth for the grid)
  rowData: any[] = [];

  constructor(
    public utils: ApilistService,
    public commonservice: CommonService,
    public globalService: GlobalService,
    public formBuilder: UntypedFormBuilder,
    private spinner: NgxSpinnerService
  ) {
    this.courseForm = this.formBuilder.group({
      categorytypeval: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      Subjecttypeval: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      documentval: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
    });

    const admin = localStorage.getItem('adminDetails');
    if (admin) {
      try {
        const adminData = JSON.parse(JSON.parse(admin));
        this.adminName = adminData[0]?.name;
        this.adminImage = adminData[0]?.image;
      } catch (e) {
        // fallback parsing
        try {
          const adminData2 = JSON.parse(admin);
          this.adminName = adminData2[0]?.name;
          this.adminImage = adminData2[0]?.image;
        } catch (err) {
          this.adminName = '';
          this.adminImage = null;
        }
      }
    }
    if (!this.adminImage) {
      this.adminImage = 'assets/tenant-avatar.jpg';
    }

    // debounce quick filter
    this.quickFilterSubject.pipe(debounceTime(250)).subscribe((q) => {
      if (this.gridApi) {
        // use any-cast for the new ag-grid typings
        (this.gridApi as any).setGridOption('quickFilterText', q ? q : null);
        // refresh so filter applies immediately
        this.gridApi.refreshClientSideRowModel('filter');
      }
    });
  }

  ngOnInit(): void {
    this.getalltopaddetails();
    this.spinner.show();
    this.courseForm.reset();
  }

  ngAfterViewInit(): void {
    // nothing special here for now
  }

  onMouseOver(e: any) {
    if (this.boxCourse && this.boxCourse.nativeElement) {
      (this.boxCourse.nativeElement as HTMLDivElement).style.pointerEvents =
        'auto';
      (this.boxCourse.nativeElement as HTMLDivElement).style.cursor = 'pointer';
    }
  }

  onChangeEvent(event: any) {
    const val = event?.target?.value;
    this.allData = this.courseData;
    if (val) {
      this.allCourse = (this.allData || []).filter((item: any) =>
        (item.courses || '').toLowerCase().includes(val.toLowerCase())
      );
    }
    if (this.allCourse == '') {
      this.globalService.showError('No data found');
    }
  }

  onChangecategory(event: any) {
    this.getmaterialsubject();
  }

  // grid ready
  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;

    // optional: fit columns to available width
    setTimeout(() => {
      try {
        this.gridApi.sizeColumnsToFit();
      } catch (e) {
        // ignore
      }
    }, 0);

    // if data already loaded, ensure grid refreshes
    if (this.rowData && this.rowData.length) {
      this.gridApi.refreshClientSideRowModel('filter');
    }
  }

  // Reset: clear search + grid filters and restore original data
  reset() {
    this.searchval = '';

    if (!this.gridApi) {
      // not yet ready: still reset local view
      this.rowData = JSON.parse(JSON.stringify(this.originalRowData || []));
      return;
    }

    // clear quick filter
    (this.gridApi as any).setGridOption('quickFilterText', null);

    // clear column filters
    this.gridApi.setFilterModel(null);

    // restore original unsorted data (update bound property)
    this.rowData = JSON.parse(JSON.stringify(this.originalRowData || []));

    // refresh so quickFilter and filters re-evaluate over the restored data
    this.gridApi.refreshClientSideRowModel('filter');
  }

  addCourse() {
    this.spinner.show();
    const formData: FormData = new FormData();
    formData.append('material_sub_id', this.subject);
    formData.append('docx_name', this.document);
    if (this.docx_file) {
      formData.append('docx', this.docx_file, this.docx_name);
    }
    const servicePath = this.utils.getApiConfigs('materialdocx');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, formData)
      .then((resp: any) => {
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.globalService.showSuccess(
            'Material Document  added Successfully'
          );
          this.display = 'none';
          this.getalltopaddetails();
          this.courseForm.reset();
        } else if (resp.status_code == '400') {
          this.globalService.showError(resp.data);
          this.display = 'none';
        }
      });
  }

  onFileSelected(event: any) {
    if (event?.target?.files?.length > 0) {
      this.docx_file = event.target.files[0];
      this.docx_name = event.target.files[0].name;
    }
  }

  openAdd() {
    this.courseForm.reset();
    this.display = 'block';
    this.showAdd = true;
    this.showEdit = false;
  }

  deleteCourse(data: any) {
    this.displayDelete = 'block';
    this.deleteErr = '';
    this.id = data.id;
  }

  onCloseHandled() {
    this.display = 'none';
    this.displayDelete = 'none';
  }

  getalltopaddetails() {
    this.spinner.show();
    const servicePath = this.utils.getApiConfigs(
      'viewallusermaterialsubscriptiondetails'
    );
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, '')
      .then((resp: any) => {
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.admissiondetails = resp.data || [];
          this.searchData = this.admissiondetails;

          // set grid data (bound property) and save original snapshot for restore
          this.rowData = [...this.admissiondetails];
          this.originalRowData = JSON.parse(
            JSON.stringify(this.admissiondetails || [])
          );

          // if grid initialized, refresh to apply filters/quickFilter
          if (this.gridApi) {
            this.gridApi.refreshClientSideRowModel('filter');
          }
        } else if (resp.status_code == '400') {
          this.globalService.showError(resp.data);
        }
      });
  }

  getmaterialsubject() {
    this.spinner.show();
    const payload = { material_cat_id: this.category };
    const servicePath = this.utils.getApiConfigs('materialonlysubject');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.subjectdata = resp.data;
        } else if (resp.status_code == '400') {
          this.globalService.showError(resp.data);
        }
      });
  }

  delete() {
    this.spinner.show();
    const payload = { id: this.id };
    const servicePath = this.utils.getApiConfigs('deletecourses');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.globalService.showSuccess('Course deleted successfully');
          this.displayDelete = 'none';
          this.getalltopaddetails();
        } else if (resp.status_code == '400') {
          this.showErr = true;
          this.deleteErr = resp.message;
        }
      });
  }

  // called from template on input - pushes into debounced subject
  onQuickFilterChanged(value: string) {
    this.searchval = value;
    this.quickFilterSubject.next(value || '');
  }

  // Client-side sort (no columnApi). Sorts rowData and refreshes grid.
  applyClientSideSort(colId: string, direction: 'asc' | 'desc' | 'none') {
    if (!this.gridApi) return;

    if (direction === 'none') {
      this.rowData = JSON.parse(JSON.stringify(this.originalRowData || []));
    } else {
      const dirMultiplier = direction === 'asc' ? 1 : -1;
      this.rowData = [...(this.rowData || [])].sort((a, b) => {
        const va = a[colId];
        const vb = b[colId];

        if (va == null && vb == null) return 0;
        if (va == null) return -1 * dirMultiplier;
        if (vb == null) return 1 * dirMultiplier;

        const na = parseFloat(va as any);
        const nb = parseFloat(vb as any);
        if (!isNaN(na) && !isNaN(nb)) return (na - nb) * dirMultiplier;

        return String(va).localeCompare(String(vb)) * dirMultiplier;
      });
    }

    // update bound data and refresh so filters/quickFilter re-run
    this.rowData = [...this.rowData];
    this.gridApi.refreshClientSideRowModel('filter');
  }

  defaultColDef = {
    resizable: true,
    sortable: true,
    filter: true,
    flex: 1,
    minWidth: 120,
  };

  gridOptions = {
    rowHeight: 48, // 🔹 makes each row taller (default 25)
  };
  // Back-compat phone-only search (if you prefer)
  onChangeEventsPhoneSearch(event: any) {
    const val = event?.target?.value;
    this.allData = this.admissiondetails;
    if (val) {
      this.searchData = (this.allData || []).filter((item: any) =>
        item.phone_num?.toString().toLowerCase().includes(val.toLowerCase())
      );
      // show phone-only results in the grid:
      this.rowData = [...this.searchData];
    } else {
      this.rowData = [...this.admissiondetails];
    }
    if (!this.searchData || this.searchData.length === 0) {
      this.globalService.showError('Data Not Found');
    } else {
      // refresh grid view
      if (this.gridApi) this.gridApi.refreshClientSideRowModel('filter');
    }
  }
}
